import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useParams } from 'react-router';
import WWResetForm from '../components/WWResetForm';

const WWReset: React.FC = () => {
  return <WWResetForm />;
};

export default WWReset;
